<script setup lang="ts">
import { isMyEasybellCom } from '@/utils/environment'

function openTariffPage() {
  if (isMyEasybellCom()) {
    window.location.href = 'https://my.easybell.com/subscription-management'
  } else {
    window.location.href = 'https://login.easybell.de/produkt'
  }
}
</script>

<template>
  <div class="absolute inset-0 flex flex-col justify-center items-center">
    <h3 class="eb-heading mb-8" data-test="overview-message-no-customer-title">
      {{ $t('notifications.noSubscription.title') }}
    </h3>
    <p class="mb-8" data-test="overview-message-no-customer-text">
      {{ $t('notifications.noSubscription.text') }}
    </p>
    <button
      data-test="overview-message-no-customer-button"
      class="eb-legacy-button eb-legacy-button--md eb-legacy-button--primary"
      @click="openTariffPage"
    >
      {{ $t('notifications.noSubscription.button') }}
    </button>
  </div>
</template>
